import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, brands } from "@fortawesome/fontawesome-svg-core/import.macro";

const ProjectItems = ({ project }) => {
  return (
    <div className="text-center text-black bg-white rounded-xl w-full">
      <img
        src={project.image.url}
        alt="project-item"
        className="mb-5 rounded-t-xl"
      />
      <div className="px-4">
        <Link
          to={`/project/${project.slug}`}
          state={project.slug}
          className="block font-semibold text-lg mb-3 hover:scale-110"
        >
          {project.title}
        </Link>
        <p className="text-sm mb-3">
          {project.excerpt}{" "}
          <Link
            to={`/project/${project.slug}`}
            state={project.slug}
            className="block hover:underline hover:scale-110"
          >
            read more...
          </Link>
        </p>

        <a
          href={project.liveLink}
          target="blank"
          className="inline-block hover:scale-110 border border-black px-4 py-2 hover:bg-black hover:text-white rounded-lg mb-2"
        >
          Visit Site <FontAwesomeIcon icon={solid("globe")} />
        </a>
        <a
          href={project.repo}
          target="blank"
          className="m-auto hover:scale-110 w-fit block border border-black px-4 py-2 hover:bg-black hover:text-white rounded-lg mb-2"
        >
          View Code <FontAwesomeIcon icon={brands("github")} />
        </a>
      </div>
    </div>
  );
};

export default ProjectItems;
